module.exports = __webpack_public_path__ + "static/img/monitorHeadBg.183439ab.png";